// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2bd27f82","239":"e2c4dea8","316":"2743a76b","361":"c1a73ebb","453":"b1276029","455":"0fcd6e25","762":"5fcead81"}[chunkId] + ".chunk.js";
};